import type { IconSvgObject } from './types';

const DiscThreeIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 6.80273C15.9109 7.32965 16.6704 8.08916 17.1973 9.00004M6.8027 15C7.32962 15.9109 8.08913 16.6704 9.00001 17.1973", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default DiscThreeIcon;
